import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Modal from 'components/Modal/Modal';
import Spin from 'components/Spin';
import Login from 'containers/login';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getUnreadNotifications } from 'store/modules/notifications/actions';
import { loadAccount, loadFeatures } from 'store/modules/settings/actions';
import { getMe } from 'store/modules/user/actions';

const StyledLogin = styled(Login)`
  height: auto;
  min-height: auto;
  .form-container {
    box-shadow: none;
    width: 90%;
    margin: 0;
  }
`;

export default ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const account = useSelector((state) => state.settings.account);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (isLoggedIn) {
      if (!user.user_id) {
        dispatch(getMe()).then((user) => {
          dispatch(loadAccount(user.account_id));
        });
      }
      dispatch(loadFeatures());
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (user.user_id && account.account_id) {
      if (!user.user_articles.length) {
        history.push(`/agreement`);
      } else if (
        account.account_type === 'user' &&
        account.connections.length === 0 &&
        user.user_onboarded !== '1'
      ) {
        history.push('/setup');
      }
      dispatch(getUnreadNotifications(user.user_id));
    }
  }, [user.user_id, account.account_id]);

  return (
    <React.Fragment>
      {!account.account_id || !account.features ? (
        <Box p={4}>
          <Spin spinning />
        </Box>
      ) : (
        children
      )}
      <Modal open={!isLoggedIn} fullWidth maxWidth="xs">
        <StyledLogin modal />
      </Modal>
    </React.Fragment>
  );
};
